<template>
	<div class="page-wrapper blur" v-bind:class="{
		'is-admin' : $route.meta.isAdmin,
		'is-scrolled': $root.$data.isScrolled,
		'header--padding' : $route.meta.isAdmin,		// <attr class='header--padding' />
		'blur--active': $root.$data.showLoginForm,
	}">

		<vue-alert v-show="$root.$data.appInitialised" />
		<site-header v-if="$root.$data.appInitialised" :class="{
			'block' : $root.$data.showLoginForm,
		}" />

		<div class="page-body" :class="{
			'block' : $root.$data.showLoginForm,
		}">

			<template v-if="$root.$data.appInitialisationFailed">
				<div class="page-container vertical-center hc">
					<p>Thank you for visiting Casino Lounge. We're currently performing maintenance on the site and we expect to be back shortly.</p>
				</div>
			</template>

			<template v-else>
				<transition name="loading">
					<loading-screen v-show="!$root.$data.appInitialised || $root.$data.appLoading" />
				</transition>
				<transition name="immediate-loading">
					<loading-screen v-show="$root.$data.appInitialised && !$root.$data.appLoading && $root.$data.appImmediateLoading" />
				</transition>
				<router-view v-if="$root.$data.appInitialised" />
			</template>

		</div>

		<game-demo-expose v-if="$mq === 'ltab' || $mq === 'desk'" :game="$root.$data.gameDemo" />
		<game-video-expose :videoId="$root.$data.gameVideoId" />
		<game-asset-expose :game="$root.$data.gameAsset" />
		<tournaments-expose />
		<login-expose :active="$root.$data.showLoginForm" />
		<site-footer v-if="$root.$data.appInitialised && $route.meta.hasFooter !== false" :class="{
			'block' : $root.$data.showLoginForm,
		}" />

	</div>
</template>

<script>
import LoadingScreen from './components/organisms/LoadingScreen'
import SiteHeader from './components/organisms/SiteHeader'
import SiteFooter from './components/organisms/SiteFooter'
import GameDemoExpose from './components/organisms/GameDemoExpose'
import GameVideoExpose from './components/organisms/GameVideoExpose'
import GameAssetExpose from './components/organisms/GameAssetExpose'
import TournamentsExpose from './components/organisms/TournamentsExpose'
import LoginExpose from './components/organisms/LoginExpose'


export default {
	name: 'App',
	components: {
		LoadingScreen,
		SiteHeader,
		SiteFooter,
		GameDemoExpose,
		GameVideoExpose,
		GameAssetExpose,
		TournamentsExpose,
		LoginExpose,
	},
	data () {
		return {
		}
	},
	mounted: function()
	{
		var self = this;

		self.$alert.hide();
	},
}
</script>

<style lang="scss">

	// Normalize
	@import '~normalize-scss/sass/normalize';
	@include normalize();

	// Breakpoints
	@import '~breakpoint-sass/stylesheets/breakpoint';

	// Variables
	@import "src/scss/vars/bootstrap";
	@import "src/scss/settings";

	@import "includes/thecodery/utils";

	@import "src/scss/utils/bootstrap";
	@import "src/scss/base/bootstrap";

	@import "includes/thecodery/app";

	@import "src/scss/layouts/bootstrap";

	@import "includes/thecodery/attract/builder";


	// Loading transition
	.loading-enter-active
	{
		transition: opacity 0.5s 1s;
	}
	.loading-leave-active
	{
		transition: opacity .25s;
	}

	.loading-enter, .loading-leave-to
	{
		opacity: 0;
	}


	// Immediate loading transition (for non-delayed screen blocking)
	.immediate-loading-enter-active
	{
		transition: opacity 1s;
	}
	.immediate-loading-leave-active
	{
		transition: opacity .25s;
	}

	.immediate-loading-enter, .immediate-loading-leave-to
	{
		opacity: 0;
	}

	.blur
	{
		@supports (backdrop-filter: blur(5px)) or (-webkit-backdrop-filter: blur(5px))
		{
			position: relative;

			&:before
			{
	 			content: "";
				position: absolute;
				z-index: -1;
				width: 0%;
				height: 0%;
				-webkit-backdrop-filter: blur(0px);
				backdrop-filter: blur(0px);
				pointer-events: none;
				transition: backdrop-filter 0.25s ease-out, -webkit-backdrop-filter 0.25s ease-out;
			}

			&--active
			{
	 			&:before
	 			{
	 				width: 100%;
	 				height: 100%;
	 				z-index: 2000;
					-webkit-backdrop-filter: blur(5px);
					backdrop-filter: blur(5px);
	 			}
			}
		}
	}

	.block
	{
		pointer-events: none;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue